export class BaseModel<ApiParser, DTO> {
  protected readonly apiParser: ApiParser;
  public readonly rawData: DTO;

  constructor({ apiParser, DTO }: { apiParser: ApiParser; DTO: DTO }) {
    this.apiParser = apiParser;
    this.rawData = DTO;
  }
}
